<div class="spacer-6"></div>
<div class="row">
  <div class="col-12 col-md-6">

  </div>
  <div class="col-12 col-md-4">
    <div class="row">
      <div class="col-12 text-center">
        <input type="file" accept=".jpg, .jpeg, .png, .pdf" (change)="uploadProfilePic($event)" class="display-none" #fileInp>
        <img *ngIf="profileImageSource" [src]="profileImageSource" (click)="virtualClick()"
          matTooltip="Click to change picture"
          onerror="if (this.src != '../../assets/avatar5.png') this.src = '../../assets/avatar5.png';">
    
        <mat-progress-bar *ngIf="isImageUploading" class="progress-bar-custom" mode="buffer">
        </mat-progress-bar>
      </div>
    </div>
    
    <br>
    
    <div class="row" *ngIf="custId">
      <div class="col-12 col-md-5 text-center">
        <strong>{{placeholder}}</strong>
      </div>
      <div class="col-12 col-md-5 text-center">
        <span>{{custId}}</span>
      </div>
    </div>
    
    <br>
    <form novalidate [formGroup]="profileForm" (submit)="updateProfile(profileForm.value)">
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input [readonly]="true" matInput type="text" placeholder="Name" formControlName="name" ng-readonly="true">
            <mat-error *ngIf="profileForm.get('name').hasError('required')">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input matInput type="tel" minlength="10" maxlength="10" placeholder="Mobile Number" formControlName="mobileNo">
            <mat-error *ngIf="profileForm.get('mobileNo').hasError('required')">
              Mobile Number is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="profileForm.get('mobileNo').hasError('pattern')">
              Please Enter valid Mobile Number
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input matInput type="email" placeholder="Email" formControlName="email">
            <mat-error *ngIf="profileForm.get('email').hasError('email')">
              Please Enter valid Email Address
            </mat-error>
            <mat-error *ngIf="profileForm.get('email').hasError('required')">
              Email is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input matInput type="text" placeholder="Customer Address" formControlName="resAdd">
            <mat-error *ngIf="profileForm.get('resAdd').hasError('resAdd')">
              Please Enter Customer Address
            </mat-error>
            <mat-error *ngIf="profileForm.get('resAdd').hasError('required')">
              Customer Address is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input minlength="6" maxlength="6" (focusin)="showpinHint=true;" (focusout)="showpinHint=false;"
              (keyup)="pincode($event)" matInput type="text" placeholder="PIN Code" formControlName="pin">
            <mat-hint *ngIf="showpinHint">Enter 6 digit PIN Code for auto fill City and State</mat-hint>
          </mat-form-field>
        </div>
      </div>
    
      <mat-progress-spinner *ngIf="isPINfetch" class="spinner-custom" mode="indeterminate"></mat-progress-spinner>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input readonly="true" matInput type="text" placeholder="City" formControlName="city">
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <mat-form-field class="w-full">
            <input readonly="true" matInput type="text" placeholder="State" formControlName="state">
          </mat-form-field>
        </div>
      </div>
    
      <div class="row form-row-padding">
        <div class="col-12 text-center">
          <button class="mybutton" type="submit" [disabled]="!profileForm.valid">Update</button>
        </div>
      </div>
    </form>
  </div>

</div>


